/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SysqueDropdownOptionsLineComponent } from './sysque-dropdown-options-line.component';
import { SysqueSelectBoxModule } from '../sysque-select-box';

@NgModule({
  declarations: [SysqueDropdownOptionsLineComponent],
  imports: [CommonModule, SysqueSelectBoxModule],
  exports: [SysqueDropdownOptionsLineComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SysqueDropdownOptionsLineModule {}
